const init_header = require('./parts/_header');
const init_parallax = require('./parts/_parallax');
const init_sticky_hero = require('./parts/_sticky');
const init_anchor = require('./parts/_anchor');
const init_swiper = require('./parts/_swiper');
const init_bb = require('./parts/_bb');
const init_forms = require('./parts/_forms');
const init_wpdt = require('./parts/_wpdt');
const init_wistia = require('./parts/_wistia');
// const init_timeline = require('./parts/_timeline');


function initialize_all() {
  init_header();
  init_parallax();
  init_sticky_hero();
  init_anchor();
  init_swiper();
  init_bb();
  init_forms();
  init_wpdt();
  init_wistia();
  // init_timeline();
}

if (document.readyState !== 'loading') {
  initialize_all();
} else {
  document.addEventListener('DOMContentLoaded', initialize_all);
}


